import { MainPageTabs } from "@/enum/common";
import { IGenerationsData, IInvestmentsData, IRegionsData, ISectorsData, ISummaryData } from "@/types/Filters";

export type IFilterDataState = {
    [MainPageTabs.summary]: {
        data: ISummaryData[] | null;
        isLoading: boolean;
    },
    [MainPageTabs.regions]: {
        data: IRegionsData[] | null;
        isLoading: boolean;
    },
    [MainPageTabs.sectors]: {
        data: ISectorsData[] | null;
        isLoading: boolean;
    },
    [MainPageTabs.generations]: {
        data: IGenerationsData[] | null;
        isLoading: boolean;
    },
    [MainPageTabs.investment]: {
        data: IInvestmentsData[] | null;
        isLoading: boolean;
    },
    data: any;
    isLoading: boolean,
}

enum FilterActionTypeEnum {
    SET_DATA = "SET_DATA",
    IS_LOADING = "IS_LOADING",
    SET_ORIGINAL_DATA = "SET_ORIGINAL_DATA",
    RESET_DATA = "RESET_DATA",
}
const initialFilterState: IFilterDataState = {
    [MainPageTabs.summary]: {
        data: null,
        isLoading: true,
    },
    [MainPageTabs.regions]: {
        data: null,
        isLoading: true,
    },
    [MainPageTabs.sectors]: {
        data: null,
        isLoading: true,
    },
    [MainPageTabs.generations]: {
        data: null,
        isLoading: true,
    },
    [MainPageTabs.investment]: {
        data: null,
        isLoading: true,
    },
    data: null,
    isLoading: true,
};

type ISetFilterDataAction = {
    type: FilterActionTypeEnum.SET_DATA,
    payload: {
        tab: MainPageTabs;
        data: any;
    };
}

type IFilterLoaderAction = {
    type: FilterActionTypeEnum.IS_LOADING,
    payload: {
        isLoading: boolean;
    };
}

type ISetOriginalDataAction = {
    type: FilterActionTypeEnum.SET_ORIGINAL_DATA,
    payload: {
        data: any;
    }
}

type IResetFilterDataAction = {
    type: FilterActionTypeEnum.RESET_DATA,
}

type FilterActionType = ISetFilterDataAction | IFilterLoaderAction | ISetOriginalDataAction | IResetFilterDataAction;

const setFilterDataAction = (tab: MainPageTabs, data: any): ISetFilterDataAction => {
    return {
        type: FilterActionTypeEnum.SET_DATA,
        payload: {
            tab,
            data,
        },
    };
};

const setFilterLoaderAction = (isLoading: boolean): IFilterLoaderAction => {
    return {
        type: FilterActionTypeEnum.IS_LOADING,
        payload: {
            isLoading,
        },
    };
};

const setOriginalFilterDataAction = (data: any): ISetOriginalDataAction => {
    return {
        type: FilterActionTypeEnum.SET_ORIGINAL_DATA,
        payload: {
            data,
        },
    };
};

const resetFilterDataAction = (): IResetFilterDataAction => {
    return {
        type: FilterActionTypeEnum.RESET_DATA,
    };
};

const filtersReducer = (state: IFilterDataState = initialFilterState, action: FilterActionType): IFilterDataState => {
    switch (action.type) {
        case FilterActionTypeEnum.SET_DATA:
        {
            const { data, tab } = action.payload;
            return {
                ...state,
                [tab]: {
                    data,
                    isLoading: false,
                },
            };
        }
        case FilterActionTypeEnum.IS_LOADING:
        {
            const { isLoading } = action.payload;
            return {
                ...state,
                isLoading,
            };
        }
        case FilterActionTypeEnum.SET_ORIGINAL_DATA:
        {
            const { data } = action.payload;
            const d: any = {};
            Object.values(MainPageTabs).forEach(key => {
                d[key] = {
                    data: data[key],
                    isLoading: false,
                };
            });
            return {
                ...state,
                data: action.payload.data,
                ...d,
            };
        }
        case FilterActionTypeEnum.RESET_DATA:
        {
            return initialFilterState;
        }
        default:
            return state;
    }
};

export {
    initialFilterState,
    filtersReducer,
    setFilterDataAction,
    setFilterLoaderAction,
    setOriginalFilterDataAction,
    resetFilterDataAction,
};
